import { createSlice } from '@reduxjs/toolkit';
import { getFormsApi, getTemplatesApi } from '../server/forms';

const initialFormsState = {
    templates: [],
    forms: [],
}

const formsSlice = createSlice({
    name: 'forms',
    initialState: initialFormsState,
    reducers: {
        updateTemplates(state, actions) {
            state.templates = actions.payload;
        },
        updateForms(state, actions) {
            state.forms = actions.payload;
        },
    }
})

export const formsActions = formsSlice.actions;
export default formsSlice;

export const fetchFormsTemplates = () => {
    return async (dispatch) => {
        try {
            const res = await getTemplatesApi();
            dispatch(formsActions.updateTemplates(res.data || []));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}

export const fetchForms = () => {
    return async (dispatch) => {
        try {
            const res = await getFormsApi();
            dispatch(formsActions.updateForms(res.data || []));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}